const queryParamsToObject = (paramNames, queryParams) => paramNames.reduce((all, key) => {
    all[key] = queryParams.get(key) || null;
    return all;
}, {});
export function saveMixpanelSuperProps(mixpanel, urlQueryString, paramNames, timestampKey) {
    const queryParams = new URLSearchParams(urlQueryString);
    const newProps = queryParamsToObject(paramNames, queryParams);
    if (paramNames.some(key => newProps[key])) {
        newProps[timestampKey] = Date.now();
        mixpanel.register(newProps);
    }
    else {
        const prevTimestamp = parseInt(mixpanel.get_property(timestampKey), 10) || 0;
        const expiryDuration = 7 * 24 * 60 * 60 * 1000;
        const isExpired = Date.now() - prevTimestamp > expiryDuration;
        if (isExpired) {
            mixpanel.unregister(timestampKey);
            Object.keys(newProps).forEach(key => mixpanel.unregister(key));
        }
    }
}
